export const environment = {
  production: false,
  apiBaseUrl: 'https://stageapi.nownowpay.ng/mfs-transaction-management',
};
